export const enum SignUpStep {
  UserCredentials = 0,
  ExtraDetails = 1,
  ConfirmMagicLink = 2,
}
